import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: ':locator/permit/:id',
    loadChildren: () => import('./views/permit/permit.module').then( m => m.PermitPageModule)
  },
  {
    path: ':locator',
    loadChildren: () => import('./views/paypark-form/paypark-form.module').then( m => m.PayparkFormPageModule)
  },
  {
    path: '',
    loadChildren: () => import('./views/home/home.module').then( m => m.HomePageModule)
  },
  { path: '**', redirectTo: '', pathMatch: 'full' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
